import { h, Transition } from 'vue'
import type { Slots } from 'vue'
interface DataDrivenTransitionProps {
  isNext?: boolean
}

const DataDrivenTransition = (
  { isNext = true }: DataDrivenTransitionProps,
  { slots }: { slots: Slots }
) => {
  const animClass = 'animate__animated animate__'
  const props = {
    appear: true,
    name: 'data-driven-transition',
    mode: 'out-in' as 'out-in' | 'in-out' | 'default',
    appearActiveClass: animClass + 'fadeInUp',
    enterActiveClass: isNext ? animClass + 'fadeInUp' : animClass + 'fadeInDown',
    leaveActiveClass: isNext ? animClass + 'fadeOutUp' : animClass + 'fadeOutDown',
    duration: 0
  }
  return h(Transition, props, slots.default ? () => (slots.default ? slots.default() : []) : [])
}

export default DataDrivenTransition
